import React, { FocusEvent } from "react";
import { Field, WrappedFieldArrayProps } from "redux-form";
import { useLocation, useNavigate } from "react-router";

import { formValidation, queryString } from "capitalrx-utilities";
import { TextField } from "capitalrx-components";
import { drugsToQueryString, getDrugsFromQueryString } from "@/App/utils/utils";
import { DrugResult } from "@/types/appTypes/drug";

const DrugListForm: React.FC<WrappedFieldArrayProps<{}>> = (props: WrappedFieldArrayProps) => {
  const { fields } = props;
  const { search } = useLocation();
  const navigate = useNavigate();
  const { required } = formValidation;

  const queryParams = queryString.getQueryParams(search);
  const drugs = getDrugsFromQueryString([].concat(queryParams.drugs));

  const handleRemove = (index: number): void => {
    const paramIndex = drugs.findIndex((drug: DrugResult) => drug.ndc === fields.get(index).ndc);

    drugs.splice(paramIndex, 1);
    queryParams["drugs"] = drugsToQueryString(drugs);
    const paramsString = queryString.convertJsonToQueryString(queryParams);

    const finalPath = "/manual-claim?" + paramsString;

    navigate(finalPath);
    fields.remove(index);
  };

  const handleQuantityFieldBlur = (e: FocusEvent<HTMLInputElement>, position: number): void => {
    const fieldValue = e.target.value;
    const queryParams = queryString.getQueryParams(search);

    const newDrugs = drugs.map((drug: DrugResult, index: number) => {
      if (fieldValue && index === position) {
        drug.quantity = fieldValue;
      }
      return drug;
    });

    delete queryParams["drugs"];
    queryParams.drugs = drugsToQueryString(newDrugs);
    navigate(`/manual-claim?${queryString.convertJsonToQueryString(queryParams)}`);
  };

  return (
    <>
      {fields.map((individualDrug, index) => (
        <div className="row" key={"row-" + index}>
          <div className="col">
            <Field
              component={TextField}
              key={"drug-name-" + index}
              id={"drug-name-" + index}
              data-testid={"drug-name-" + index}
              name={`${individualDrug}.drug_name`}
              label="Drug Name"
              readOnly={true}
            />
          </div>
          <div className="col">
            <Field
              component={TextField}
              key={"drug-ndc-" + index}
              id={"drug-ndc-" + index}
              data-testid={"drug-ndc-" + index}
              name={`${individualDrug}.ndc`}
              label="NDC"
              type="text"
              readOnly={true}
            />
          </div>
          <div className="col">
            <Field
              component={TextField}
              key={"drug-strength-" + index}
              id={"drug-strength-" + index}
              data-testid={"drug-strength-" + index}
              name={`${individualDrug}.dosage`}
              label="Strength"
              readOnly={true}
            />
          </div>
          <div className="col">
            <Field
              component={TextField}
              key={"drug-form-" + index}
              id={"drug-form-" + index}
              data-testid={"drug-form-" + index}
              name={`${individualDrug}.dosage_form`}
              label="Form"
              readOnly={true}
            />
          </div>
          <div className="col">
            <Field
              component={TextField}
              key={"drug-qty-" + index}
              id={"drug-qty-" + index}
              data-testid={"drug-qty-" + index}
              name={`${individualDrug}.quantity`}
              label="Quantity"
              validate={[required]}
              onBlur={(e: FocusEvent<HTMLInputElement>): void => handleQuantityFieldBlur(e, index)}
              type="text"
            />
          </div>
          <div
            key={"remove-button-" + index}
            data-testid={"remove-drug-" + index}
            className="col caprx-f-elem-root drug-item-remove"
            onClick={(): void => {
              handleRemove(index);
            }}
          >
            <span className="caprx-icon-inputclose">REMOVE</span>
          </div>
        </div>
      ))}
    </>
  );
};

export default DrugListForm;
